/**
 * Merge multiple refs
 * @param {array} refs
 */
function useMergeRefs(refs) {
  if (!refs || !refs.length) return null;
  return refValue => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(refValue);
      } else if (ref != null) {
        ref.current = refValue;
      }
    });
  };
}
export default useMergeRefs;